import React, { useState } from 'react';
import { Menu, X, Lock } from 'lucide-react';
export type ServiceType = 'foretagsbestallning' | 'manadens_meny' | 'catering_event';
interface NavigationProps {
  onOrderClick: (type: ServiceType) => void;
}
export function Navigation({
  onOrderClick
}: NavigationProps) {
  const [isOpen, setIsOpen] = useState(false);
  const handleLinkClick = (type: ServiceType) => {
    onOrderClick(type);
    setIsOpen(false);
  };
  const links: {
    label: string;
    type: ServiceType;
  }[] = [{
    label: 'Företagsbeställning',
    type: 'foretagsbestallning'
  }, {
    label: 'Catering & Event',
    type: 'catering_event'
  }];
  return <nav className="sticky top-0 z-40 w-full bg-[#FFF8F0] border-b border-[#C5A55A]/15 shadow-sm" data-id="element-381">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-382">
        <div className="flex justify-center items-center h-12" data-id="element-383">
          {/* Desktop Menu - Centered */}
          <div className="hidden md:flex items-center space-x-10" data-id="element-384">
            {links.map(link => <button key={link.type} onClick={() => handleLinkClick(link.type)} className="flex items-center gap-1.5 text-sm font-medium text-[#1A1A1A]/40 cursor-not-allowed tracking-wide" title="Inte tillgängligt just nu" data-id="element-385">
                <Lock className="w-3 h-3" data-id="element-386" />
                {link.label}
              </button>)}
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center gap-2" data-id="element-387">
            <button onClick={() => setIsOpen(!isOpen)} className="flex items-center gap-2 px-3 py-1.5 rounded-lg text-[#1A1A1A]/70 hover:bg-[#C5A55A]/10 focus:outline-none transition-colors" aria-label="Meny" aria-expanded={isOpen} data-id="element-388">
              {isOpen ? <X className="h-5 w-5" data-id="element-389" /> : <Menu className="h-5 w-5" data-id="element-390" />}
              <span className="text-sm font-medium tracking-wide" data-id="element-391">
                {isOpen ? 'Stäng' : 'Beställ & Tjänster'}
              </span>
            </button>
          </div>
        </div>
      </div>

      {isOpen && <div className="md:hidden bg-[#FFF8F0] border-t border-[#C5A55A]/10 animate-in slide-in-from-top-2 duration-200" data-id="element-392">
          <div className="px-4 pt-3 pb-4 space-y-1" data-id="element-393">
            <p className="text-xs text-[#1A1A1A]/40 uppercase tracking-wider font-medium px-3 pb-2" data-id="element-394">
              Våra tjänster
            </p>
            {links.map(link => <button key={link.type} onClick={() => handleLinkClick(link.type)} className="flex items-center gap-2 w-full text-left px-3 py-3 rounded-lg text-base font-medium text-[#1A1A1A]/40 cursor-not-allowed" data-id="element-395">
                <Lock className="w-4 h-4" data-id="element-396" />
                {link.label}
              </button>)}
          </div>
        </div>}
    </nav>;
}